import { IFiguresPickerData, IFigurePickerFigure } from "src/api/server/extended-search.types";
import { ISearchTableFigure } from "src/components/pages/search/components/table/search-table.types";

const toTableFigure = (figure: IFigurePickerFigure): ISearchTableFigure => ({
    id: figure.id,
    label: figure.label,
    fullLabel: figure.fullLabel,
    orderDescending: figure.orderDescending,
    tooltip: { content: figure.tooltip?.content ?? "", link: figure.tooltip?.link ?? null },
});

export const mapStoreFiguresToSearchTableFigures = (
    figuresPicker: IFiguresPickerData | undefined,
    selectedFigureIds: ReadonlyArray<string>
): ISearchTableFigure[] => {
    if (!figuresPicker) {
        return [];
    }

    const figuresById = new Map(figuresPicker.figureGroups.flatMap(group => group.data).map(figure => [figure.id, figure]));
    const selectedFigures = selectedFigureIds.map(id => figuresById.get(id)).filter((figure): figure is IFigurePickerFigure => Boolean(figure));
    const resolvedFigures = selectedFigures.length > 0 ? selectedFigures : figuresPicker.defaultFigures;

    return resolvedFigures.map(toTableFigure);
};
